import { createTheme } from './createTheme';
import { theme } from './theme';

export const defaultTheme = createTheme(theme);

export type DefaultTheme = typeof defaultTheme;
